import React from 'react';
import { Button } from '@sparknz/spark-pattern-library';

import { useProductDetails } from 'journey/productDetails/provider';
import { ProductDetailsActionTypes } from 'journey/productDetails/reducer/productDetails.reducer';
import {
  ActionLayerStatus,
  IfpEligibilityCheckSteps,
} from 'journey/productDetails/typings';

const { AccountSelection, LineSelection, AddToCart } = IfpEligibilityCheckSteps;

interface AuthenticatedIfpEligibilityCheckButtonProps {
  setActiveIfpCheckStep: (step: IfpEligibilityCheckSteps) => void;
  disabled: boolean;
}

export default function AuthenticatedIfpEligibilityCheckButton({
  setActiveIfpCheckStep,
  disabled,
}: AuthenticatedIfpEligibilityCheckButtonProps) {
  const { dispatch, ifpEligibility } = useProductDetails();

  function handleClick() {
    if (!ifpEligibility.selectedAccountNumber) {
      dispatch({
        type: ProductDetailsActionTypes.SetActionLayer,
        actionLayerStatus: ActionLayerStatus.ShowExistingPlan,
        ifpEligibility: {
          activeStep: IfpEligibilityCheckSteps.AccountSelection,
          isChangePlan: false,
        },
      });
      setActiveIfpCheckStep(AccountSelection);
      return;
    }

    if (!ifpEligibility.selectedLineNumber) {
      dispatch({
        type: ProductDetailsActionTypes.SetActionLayer,
        actionLayerStatus: ActionLayerStatus.ShowExistingPlan,
        ifpEligibility: {
          activeStep: IfpEligibilityCheckSteps.LineSelection,
          selectedLineNumber: ifpEligibility.selectedLineNumber,
          isChangePlan: false,
        },
      });
      setActiveIfpCheckStep(LineSelection);
      return;
    }
    setActiveIfpCheckStep(AddToCart);
  }

  return (
    <Button variant="primary" onClick={handleClick} disabled={disabled}>
      Check eligibility
    </Button>
  );
}
